/**
 * Tags UI is shown in the dashboard rail (#tags-explore-rail) when `tagsExploreRailOpen` is true (Tags sidebar item).
 * This module exists so the Vite report glob and menu file_path resolve correctly.
 */
export default function TagsExploreStub() {
  return null;
}
